import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly10B2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10B/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10B/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10B/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10B/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10B/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10B/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10B/7.webp`;
  const p8 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10B/8.webp`;
  const p9 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10B/9.webp`;


  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
    { src: p7, source: p7, rows: 1, cols: 1 },
    { src: p8, source: p8, rows: 1, cols: 1 },
    { src: p9, source: p9, rows: 1, cols: 1 },
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                  Back to Nature: The Healing Power of Prakriti Chikitsa
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 10B   Date: 11 & 12 June 2026
                </Typography>

        <Typography variant={'subtitle1'} align={'justify'}>
        The students of Class 10 B presented their class assembly on the theme
        <strong> “Back to Nature: The Healing Power of Prakriti Chikitsa.”</strong>
        The assembly created awareness about natural methods of maintaining health and
        well-being through proper diet, exercise, sunlight, fresh air and positive
        lifestyle choices.
        <br></br>
        On 11 June 2026, the programme began with the Thought for the Day,
        emphasizing the importance of living in harmony with nature. Students then
        presented an informative speech highlighting the principles of naturopathy
        and its role in promoting physical, mental and emotional wellness. The
        assembly also featured a segment titled <strong>“Amazing Facts About Naturopathy”</strong>,
        where students shared fascinating insights into natural healing practices.
        <br></br>
        The students presented an engaging skit depicting the life of a student who
        relied heavily on junk food, gadgets and a sedentary lifestyle. Through the
        guidance of a naturopathy practitioner, the student learned the importance of
        healthy eating, regular exercise, adequate sleep and spending time in nature.
        The skit concluded with the message that prevention is better than cure and
        that nature provides simple yet effective ways to maintain good health.
        <br></br>
        Overall, the assembly programme successfully spread awareness about the
        benefits of naturopathy and inspired students to adopt healthier lifestyle
        practices. It highlighted the significance of natural healing methods and
        encouraged everyone to maintain a balanced and sustainable way of life.
        <br></br>
        </Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
                &ldquo;"Nature itself is the best physician."&rdquo;
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 10B 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly10B2026;
